export const $apiLinks = "https://admin.hezhiying.com.cn/" // api 接口地址
export const baseUrl = "https://admin.hezhiying.com.cn/"